import { render, staticRenderFns } from "./MultimediaCard.vue?vue&type=template&id=0fa9e2ac&"
import script from "./MultimediaCard.vue?vue&type=script&lang=js&"
export * from "./MultimediaCard.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaCard.vue?vue&type=style&index=0&id=0fa9e2ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports